
import { NgPermissionGroups } from './index';
import { NgTenants } from './index';
import { NgUsers } from './index';

export class NgEmployeeXpermissionGroup {
   public employeeXpermissionGroupId: number = 0;
   public employeeId: number = null;
   public permissionGroupId: number = 0;
   public tenantId: number = 0;
   public userId: number = 0;
   public permissionGroup: NgPermissionGroups = null;
   public tenant: NgTenants = null;
   public user: NgUsers = null;
}